import { useEffect } from "react";
import { useLocation } from "wouter";
import { syncDocumentMetaFromPath } from "@/lib/route-meta";

/**
 * Keeps document title and meta description in sync with the URL (SPA).
 * Blog posts override description/title when loaded (see blog-post.tsx).
 */
export function DocumentMeta() {
  const [location] = useLocation();

  useEffect(() => {
    syncDocumentMetaFromPath(location);
  }, [location]);

  return null;
}
